var consumer = {
  "units": {
    "Wh": {
      "single": "watogodzina",
      "plural": "watogodziny",
      "annotated_abv": "(Wh)",
      "abv": "Wh",
      "definition": "Produkcja i zużycie energii mierzy się w watogodzinach (Wh). Kilowatogodzina (kWh) jest równa 1000 watogodzin. Jest jednostką powszechnie używaną przez dostawców energii elektrycznej, widoczną na miesięcznych rachunkach za prąd."
    },
    "kWh": {
      "single": "kilowatogodzina",
      "plural": "kilowatogodziny",
      "annotated_abv": "(kWh)",
      "abv": "kWh"
    },
    "MWh": {
      "single": "megawatogodzina",
      "plural": "megawatogodziny",
      "annotated_abv": "(MWh)",
      "abv": "MWh"
    },
    "GWh": {
      "single": "gigawatogodzina",
      "plural": "gigawatogodziny",
      "annotated_abv": "(GWh)",
      "abv": "GWh"
    },
    "TWh": {
      "single": "terawatogodzina",
      "plural": "terawatogodziny",
      "annotated_abv": "(TWh)",
      "abv": "TWh"
    },
    "PWh": {
      "single": "petawatogodzina",
      "plural": "petawatogodziny",
      "annotated_abv": "(PWh)",
      "abv": "PWh"
    },
    "EWh": {
      "single": "eksawatogodzina",
      "plural": "eksawatogodziny",
      "annotated_abv": "(EWh)",
      "abv": "EWh"
    },
    "ZWh": {
      "single": "zettawatogodzina",
      "plural": "zettawatogodziny",
      "annotated_abv": "(ZWh)",
      "abv": "ZWh"
    },
    "YWh": {
      "single": "jottawatogodzina",
      "plural": "jottawatogodziny",
      "annotated_abv": "(YWh)",
      "abv": "YWh"
    },
    "W": {
      "single": "wat",
      "plural": "waty",
      "annotated_abv": "(W)",
      "abv": "W"
    },
    "kW": {
      "single": "kilowat",
      "plural": "kilowaty",
      "annotated_abv": "(kW)",
      "abv": "kW"
    },
    "MW": {
      "single": "megawat",
      "plural": "megawaty",
      "annotated_abv": "(MW)",
      "abv": "MW"
    },
    "GW": {
      "single": "gigawat",
      "plural": "gigawaty",
      "annotated_abv": "(GW)",
      "abv": "GW"
    },
    "TW": {
      "single": "terawat",
      "plural": "terawaty",
      "annotated_abv": "(TW)",
      "abv": "TW"
    },
    "PW": {
      "single": "petawat",
      "plural": "petawaty",
      "annotated_abv": "(PW)",
      "abv": "PW"
    },
    "EW": {
      "single": "eksawat",
      "plural": "eksawaty",
      "annotated_abv": "(EW)",
      "abv": "EW"
    },
    "ZW": {
      "single": "zettawat",
      "plural": "zettawaty",
      "annotated_abv": "(ZW)",
      "abv": "ZW"
    },
    "YW": {
      "single": "jottawat",
      "plural": "jottawaty",
      "annotated_abv": "(YW)",
      "abv": "YW"
    },
    "percent": {
      "single": "procent",
      "plural": "procent",
      "annotated_abv": "%",
      "abv": "%"
    },
    "minutes": {
      "zero": "minut",
      "ltone": "minuto",
      "single": "minuta",
      "plural": "minut"
    },
    "hours": {
      "zero": "horas",
      "ltone": "hora",
      "single": "godzina",
      "plural": "godzin"
    },
    "months": {
      "zero": "miesiące",
      "ltone": "miesiąc",
      "single": "miesiąc",
      "plural": "miesiące"
    },
    "years": {
      "zero": "lata",
      "ltone": "rok",
      "single": "rok",
      "plural": "lata"
    },
    "days": {
      "zero": "dias",
      "ltone": "dia",
      "single": "dzien",
      "plural": "dni"
    },
    "nights": {
      "zero": "noce",
      "ltone": "noc",
      "single": "noc",
      "plural": "nocy"
    },
    "batteries": {
      "zero": "akumulatory",
      "ltone": "Bateria",
      "single": "Bateria",
      "plural": "akumulatory"
    },
    "trees": {
      "zero": "Drzew",
      "ltone": "Árvore",
      "single": "Drzewo",
      "plural": "Drzew"
    },
    "kg": {
      "zero": "kg",
      "ltone": "kg",
      "single": "kg",
      "plural": "kg"
    },
    "laps": {
      "zero": "okrążenia",
      "ltone": "okrążenie",
      "single": "okrążenie",
      "plural": "okrążenia"
    },
    "barrels": {
      "zero": "beczki",
      "ltone": "beczka",
      "single": "beczka",
      "plural": "beczki"
    },
    "flights": {
      "zero": "loty",
      "ltone": "lot",
      "single": "lot",
      "plural": "loty"
    },
    "launches": {
      "zero": "uruchomienia",
      "ltone": "uruchomienie",
      "single": "uruchomienie",
      "plural": "uruchomienia"
    }
  },
  "timeAgo": {
    "now": "Now",
    "second": {
      "single": "1 s temu",
      "plural": "%{number} s temu"
    },
    "minute": {
      "single": "1 min temu",
      "plural": "%{number} min temu"
    },
    "hour": {
      "single": "1 h temu",
      "plural": "%{number} h temu"
    },
    "day": {
      "single": "1 dzień temu",
      "plural": "%{number} dni temu"
    },
    "week": {
      "single": "1 tydzień temu",
      "plural": "%{number} tyg. temu"
    },
    "month": {
      "single": "1 mies. temu",
      "plural": "%{number} mies. temu"
    },
    "year": {
      "single": "1 rok temu",
      "plural": "%{number} lat(-a) temu"
    }
  },
  "weather": {
    "unknown": "Pogoda nieznana",
    "footer": "Dane pogodowe dostarczane przez The Weather Company.",
    "credit": "Dostarczane przez The Weather Company"
  },
  "reports": {
    "title": "Raporty",
    "submit": "Sporządź raport",
    "to": "do",
    "selectDate": "Select the date",
    "insufficientData": "Sprawdź ponownie jutro. Chmura Enphase nie zebrała danych wymaganych do wygenerowania raportów.",
    "1": {
      "name": "Produkcja dzienna",
      "title": "Produkcja energii w lokalizacji",
      "description": "Podsumowanie dziennej produkcji energii w tej lokalizacji. Ponieważ ten raport przedstawia dzienną produkcję energii, możesz zażądać daty do wczoraj włącznie."
    },
    "2": {
      "name": "Bieżąca produkcja",
      "title": "Bieżąca produkcja energii w lokalizacji",
      "description": "Podsumowanie ostatniego tygodnia produkcji energii w tej lokalizacji w 5-minutowych odstępach."
    },
    "6": {
      "name": "Produkcja miesięczna",
      "title": "Miesięczna produkcja energii",
      "description": "Podsumowanie miesięcznej produkcji energii i mocy szczytowej w tej lokalizacji."
    },
    "15": {
      "name": "Zużycie dzienne",
      "title": "Zużycie energii w lokalizacji",
      "description": "Podsumowanie zużycia dziennego energii w tej lokalizacji. Ponieważ ten raport przedstawia dzienną produkcję energii, możesz zażądać daty do wczoraj włącznie."
    },
    "16": {
      "name": "Bieżące zużycie",
      "title": "Bieżące zużycie energii w lokalizacji",
      "description": "Podsumowanie ostatniego tygodnia zużycia energii w tej lokalizacji w 15-minutowych odstępach."
    },
    "17": {
      "name": "Miesięczna energia netto",
      "title": "Miesięczna energia netto",
      "description": "Ten raport podsumowuje energię wyprodukowaną, zużytą, zaimportowaną i wyeksportowaną z tej lokalizacji dla każdych 15 minut wybranego miesiąca. Jeśli system wyposażony jest w akumulatory AC, raport zestawia również zmagazynowaną i zużytą energię."
    },
    "19": {
      "name": "Raport dot. akumulatora",
      "title": "Raport dot. akumulatora",
      "description": "Ten raport zawiera dane dotyczące akumulatora z ostatnich 7 dni"
    },
    "3": {
      "name": "Dzienna produkcja energii na moduł",
      "title": "Dzienna produkcja energii na moduł",
      "description": "Ten raport przedstawia produkcję energii wszystkich mikroinwerterów w określonym czasie."
    },
    "5": {
      "name": "Miesięczna produkcja energii na moduł",
      "title": "Miesięczna produkcja energii na moduł",
      "description": "Ten raport przedstawia produkcję energii wszystkich mikroinwerterów w określonym miesiącu."
    },
    "20": {
      "name": "Raport z autotestu przekaźnika IQ-Relay",
      "title": "Raport z wyników autotestu przekaźnika IQ-Relay",
      "description": "Ten raport zawiera najnowsze wyniki autotestu przekaźnika IQ-Relay"
    },
    "25": {
      "name": "Raport niestandardowy (w Wh)",
      "title": "Raport niestandardowy",
      "description": ""
    }
  },
  "stats": {
    "total": "Energia całkowita",
    "peak_production": "Pico de energia",
    "latest_production": "Acionamento mais recente",
    "peak_consumption": "Zużycie szczytowe",
    "latest_consumption": "Ostatnie zużycie",
    "recent_power": "Bieżąca moc",
    "maintainer": "Skontaktuj się z serwisantem",
    "enphase": "Skontaktuj się z obsługą klienta Enphase",
    "orenphase": "Lub skontaktuj się z obsługą klienta Enphase",
    "learn_more": "Saiba mais.",
    "where": "Na czym polega problem?",
    "toGrid": "Do sieci wyeksportowano około %{value}",
    "fromGrid": "Z sieci zaimportowano około %{value}",
    "normal": {
      "title": "Normalne",
      "modal": "System działa normalnie."
    },
    "shortcomm": {
      "title": "Brama nie zgłasza się",
      "hours": "Twój system nie raportował danych do chmury Enphase przez ostatnie %{hours} godz.",
      "date": "Twój system nie raportował danych do chmury Enphase od %{date}.",
      "unknown": "Ten system nie raportuje do chmury Enphase.",
      "question": "Czy Twoje połączenie internetowe nie działa?",
      "help_topic_link": "Połącz się ponownie, aby zobaczyć, jak działa Twój system.",
      "link": "Kliknij tutaj, aby uzyskać pomoc."
    },
    "meter": {
      "title": "Miernik nie zgłasza",
      "hours": "Miernik systemu nie przesyłał danych do bramy przez ostatnie %{hours} h.",
      "date": "Miernik systemu nie przesyłał danych do bramy od %{date}.",
      "ct_wiring": "Wystąpił problem z pomiarami miernika bramy. Skontaktuj się z serwisantem, aby uzyskać pomoc.",
      "unknown": "Miernik systemu nie przesyła danych do bramy.",
      "link": "Kliknij tutaj, aby uzyskać pomoc.",
      "modal": "Twój miernik nie przesłał danych do bramy od"
    },
    "meter_issue": {
      "title": "Problem z miernikiem",
      "ct_wiring": "Wystąpił problem z pomiarami miernika Envoy",
      "link": "Kliknij tutaj, aby uzyskać pomoc."
    },
    "battery": {
      "title": "Akumulatory AC nie zgłaszają",
      "modal": "Ten akumulator AC nie przesyła danych.",
      "message": "Niektóre akumulatory AC nie przesyłają danych.",
      "messageSome": "Niektóre akumulatory AC (%{count}) nie przesyłają danych.",
      "link": "Kliknij tutaj, aby uzyskać pomoc."
    },
    "storage_idle": {
      "title": "Pamięć nieaktywna",
      "modal": "Ten akumulator AC nie ładuje lub nie rozładowuje się.",
      "date": "Co najmniej jeden akumulator AC nie ładował lub rozładowywał się od %{date}.",
      "unknown": "Co najmniej jeden akumulator AC nie ładuje lub nie rozładowuje się.",
      "link": "Kliknij tutaj, aby uzyskać pomoc."
    },
    "encharge": {
      "title": "Akumulator nie zgłasza się",
      "modal": "Ten akumulator nie przesyła danych.",
      "message": "Akumulator nie przesyła danych. Może się tak zdarzyć, jeśli komunikacja bezprzewodowa między bramą a akumulatorem jest słaba. Może to być tymczasowa usterka, która wkrótce powinna zostać wyeliminowana.",
      "requestMaintainer": "Jeśli problem nie zniknie, skontaktuj się z konserwatorem w celu uzyskania pomocy.",
      "messageSome": "Niektóre akumulatory (%{count}) nie przesyłają danych.",
      "link": "Kliknij tutaj, aby uzyskać pomoc."
    },
    "enpower": {
      "title": "Sterownik systemu nie zgłasza się",
      "modal": "Ten sterownik systemu nie przesyła danych.",
      "message": "Sterownik systemu nie przesyła danych. Może się tak zdarzyć, jeśli komunikacja bezprzewodowa między bramą a sterownikiem systemu jest słaba. Może to być tymczasowa usterka, która wkrótce powinna zostać wyeliminowana.",
      "requestMaintainer": "Jeśli problem nie zniknie, skontaktuj się z konserwatorem w celu uzyskania pomocy.",
      "messageSome": "Niektóre sterowniki systemu (%{count}) nie przesyłają danych.",
      "link": "Kliknij tutaj, aby uzyskać pomoc."
    },
    "encharge_issue": {
      "title": "Błąd akumulatora",
      "modal": "W tym akumulatorze wystąpił błąd.",
      "message": "Wystąpił błąd akumulatora."
    },
    "enpower_issue": {
      "title": "Błąd sterownika systemu",
      "modal": "W tym sterowniku systemu wystąpił błąd.",
      "message": "W sterowniku systemu wystąpił błąd."
    },
    "micro": {
      "title": "Microinversores sem relatório",
      "modal": "Ten mikroinwerter nie przesyła danych do bramy.",
      "message": "Niektóre mikroinwertery nie przesyłają danych do bramy.",
      "messageSome": "Niektóre mikroinwertery (%{count}) nie przesyłają danych do bramy.",
      "messageAll": "Żaden mikroinwerter nie przesyła danych do bramy.",
      "link": "Kliknij tutaj, aby uzyskać pomoc."
    },
    "power": {
      "title": "Problema de produção do sistema",
      "message": "Wystąpił problem z produkcją energii w Twoim systemie.",
      "messageSome": "Ten mikroinwerter zgłasza problem z produkcją energii.",
      "messageThreshold": "System produkuje mniej energii niż oczekiwano.",
      "link": "Skontaktuj się z obsługą klienta Enphase, aby uzyskać pomoc.",
      "maintainerlink": "Skontaktuj się z serwisantem, aby uzyskać pomoc."
    },
    "data_upload": {
      "title": "Transferência de dados em progresso"
    }
  }
};
module.exports = consumer;